module.exports = __webpack_public_path__ + "img/1492748918.5d33c5fa.jpg";